/** @format */

import { InternalFieldContainer } from '@/components/shared/StaticField/index.style';
import styled from 'styled-components';

export const MapWrapper = styled.div`
  contain: layout paint;
  position: relative;
  width: 100%;
  height: 100%;

  .mapboxgl-popup {
    z-index: 3;
  }
  .mapboxgl-popup-tip {
    display: none;
  }

  .mapboxgl-popup-content {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    overflow: hidden;
    .mapboxgl-popup-close-button {
      display: none;
    }
  }

  .mapboxgl-ctrl-logo {
    display: none !important;
  }
  .mapboxgl-marker {
    &:hover {
      display: block;
      z-index: 2;
    }
  }

  .mapboxgl-ctrl-top-right,
  .mapboxgl-ctrl-top-left {
    z-index: 4;
  }

  .mapboxgl-ctrl-geocoder {
    background: transparent;
    box-shadow: rgba(16, 24, 40, 0.08) 0px 12px 16px -4px, rgba(16, 24, 40, 0.03) 0px 4px 6px -2px;
    .mapboxgl-ctrl-geocoder--icon-search {
      z-index: 1;
      top: 50%;
      transform: translateY(-50%);
    }
    .mapboxgl-ctrl-geocoder--button {
      top: 11px;
      svg {
        margin-top: 0;
      }
    }

    .mapboxgl-ctrl-geocoder--input {
      font-family: ${({ theme }) => theme.font.body};
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.625rem 0.875rem;
      padding-left: 2.25rem;
      background: ${({ theme }) => theme.colors.joivy.white};
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
      border-radius: 0.5rem;
      border: 1px solid rgb(208, 213, 221);
      color: #101828;
      font-size: 0.875rem;
      font-weight: 500;
      line-height: 1.25rem;
      gap: 0.5rem;
      cursor: pointer;
      position: relative;
      height: 40px;

      &::before {
        content: '';
        position: absolute;
        inset: 0;
        border: 1px solid #d0d5dd;
        border-radius: 0.5rem;
        transition: all 100ms linear;
      }

      &.dropdown-open,
      &:hover,
      &:active,
      &:focus {
        border: 1px solid ${({ theme }) => theme.colors.joivy['teal-dark']};
        outline: none;
      }

      > span {
        max-width: 12rem;
        text-overflow: ellipsis;
        text-wrap: nowrap;
        overflow: hidden;
      }
    }

    .suggestions-wrapper * {
      & > * {
        font-family: ${({ theme }) => theme.font.body};
      }

      .suggestions > li > a {
        color: var(--gray-900);
      }
      li.active > a,
      a:hover {
        background-color: #ccdddf;
      }
    }
  }
`;
